var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"blue","close":"","outline":""},on:{"input":function($event){return _vm.$emit('input', { index: _vm.index, value: _vm.value })}}},[_vm._v("\n  "+_vm._s(_vm.displayText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }